const CardSkeleton: React.FC = () => {
	return (
		<div className="flex flex-col rounded-lg border border-stroke-secondary shadow-sm">
			<div className="h-40 rounded-t-lg bg-surface-primary-pressed" />
			<div className="p-4">
				<div className="mb-2 h-4 rounded bg-surface-primary-pressed" />
				<div className="mb-2 h-4 rounded bg-surface-primary-pressed" />
				<div className="mb-4 h-4 rounded bg-surface-primary-pressed" />
				<div className="mb-2 h-10 rounded-small bg-surface-primary-pressed" />
			</div>
		</div>
	);
};

export const LoadingCardsSkeleton: React.FC = () => {
	return (
		<div
			data-qa="suggested-petitions"
			className="grid animate-pulse grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
		>
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
		</div>
	);
};
